module.exports = __webpack_public_path__ + "static/media/mobile_chatbots.175046e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/Chatbots_crm/mobile_chatbots.png
// module id = 278
// module chunks = 0